import * as React from "react";

import { reject } from "../../../../../../../../Common/TypingUtils";
import { LinkParserWrapper } from "../../../../../../Controls/Helpers/LinkWrapper/LinkParserWrapper";

export interface IZeroReportOptions {
    getOptions(): { options?: React.ReactNode; validationPath?: string; description?: string | React.ReactNode };
}

const ZeroReportOptionsContext = React.createContext<IZeroReportOptions | undefined>(undefined);

export function useZeroReportOptions(): IZeroReportOptions {
    return React.useContext(ZeroReportOptionsContext) ?? reject("ZeroReportOptions is not provided");
}

interface ModalManagerProviderProps {
    children: React.ReactNode;
    options?: React.ReactNode;
    validationPath?: string;
    description?: string;
}

export function ZeroReportOptionsProvider(props: ModalManagerProviderProps): JSX.Element {
    const value = {
        getOptions: () => ({
            options: props.options,
            validationPath: props.validationPath,
            description: LinkParserWrapper(props.description),
        }),
    };
    return <ZeroReportOptionsContext.Provider value={value}>{props.children}</ZeroReportOptionsContext.Provider>;
}
